(() => {
  document.querySelectorAll('.wearse-medical-ar').forEach((root) => {
    const openButton = root.querySelector('[data-wearse-video-open]');
    const modal = root.querySelector('[data-wearse-video-modal]');
    const closeButton = root.querySelector('[data-wearse-video-close]');

    if (!openButton || !modal) return;

    const stopVideo = () => {
      modal.querySelectorAll('video').forEach((video) => {
        video.pause();
        video.currentTime = 0;
      });

      modal.querySelectorAll('iframe').forEach((iframe) => {
        iframe.src = iframe.dataset.originalSrc || iframe.src;
      });
    };

    const closeModal = () => {
      stopVideo();
      if (modal.open) modal.close();
      openButton.focus({ preventScroll: true });
    };

    openButton.addEventListener('click', () => {
      modal.showModal();

      const video = modal.querySelector('video');
      if (video) video.play().catch(() => {});

      const iframe = modal.querySelector('iframe');
      if (iframe) {
        iframe.dataset.originalSrc ||= iframe.src;
        const url = new URL(iframe.src);
        url.searchParams.set('autoplay', '1');
        iframe.src = url.toString();
      }
    });

    closeButton?.addEventListener('click', closeModal);
    modal.addEventListener('close', stopVideo);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });

    const testimonials = root.querySelector('[data-wearse-testimonials]');
    const slides = testimonials ? [...testimonials.querySelectorAll('[data-wearse-testimonial-slide]')] : [];
    const dots = testimonials ? [...testimonials.querySelectorAll('[data-wearse-testimonial-dot]')] : [];

    if (slides.length) {
      let activeIndex = 0;
      let startX = null;
      let timer;

      const getVisibleCount = () => window.matchMedia('(max-width: 749px)').matches ? 1 : 3;
      const showSlide = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        const visibleCount = getVisibleCount();
        slides.forEach((slide, slideIndex) => {
          const distance = (slideIndex - activeIndex + slides.length) % slides.length;
          slide.hidden = distance >= visibleCount;
        });
        dots.forEach((dot, dotIndex) => {
          if (dotIndex === activeIndex) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const stopRotation = () => window.clearInterval(timer);
      const startRotation = () => {
        stopRotation();
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(() => showSlide(activeIndex + 1), 5500);
        }
      };

      testimonials.querySelector('[data-wearse-testimonial-prev]')?.addEventListener('click', () => {
        showSlide(activeIndex - 1);
        startRotation();
      });
      testimonials.querySelector('[data-wearse-testimonial-next]')?.addEventListener('click', () => {
        showSlide(activeIndex + 1);
        startRotation();
      });
      dots.forEach((dot) => dot.addEventListener('click', () => {
        showSlide(Number(dot.dataset.wearseTestimonialDot));
        startRotation();
      }));
      testimonials.addEventListener('pointerenter', stopRotation);
      testimonials.addEventListener('pointerleave', startRotation);
      testimonials.addEventListener('touchstart', (event) => {
        startX = event.changedTouches[0].clientX;
        stopRotation();
      }, { passive: true });
      testimonials.addEventListener('touchend', (event) => {
        if (startX !== null && Math.abs(event.changedTouches[0].clientX - startX) > 45) {
          showSlide(activeIndex + (event.changedTouches[0].clientX < startX ? 1 : -1));
        }
        startX = null;
        startRotation();
      }, { passive: true });
      window.addEventListener('resize', () => showSlide(activeIndex));
      showSlide(0);
      startRotation();
    }
  });
})();
